import { render, staticRenderFns } from "./event-detail-profile.vue?vue&type=template&id=4c2292a5&scoped=true&"
import script from "./event-detail-profile.vue?vue&type=script&lang=js&"
export * from "./event-detail-profile.vue?vue&type=script&lang=js&"
import style0 from "./event-detail-profile.vue?vue&type=style&index=0&id=4c2292a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2292a5",
  null
  
)

export default component.exports